/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import {
	NbAlertModule,
	NbButtonModule,
	NbCheckboxModule,
	NbDatepickerModule,
	NbDialogModule,
	NbIconModule,
	NbLayoutModule, NbMenuModule,
	NbSidebarModule,
	NbTimepickerModule,
	NbToastrModule,
	NbWindowModule
} from '@nebular/theme';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Hammer from 'hammerjs';
import { environment } from '../environments/environment';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { PwaService } from './shared/services/pwa.service';
import { SharedModule } from './shared/shared.module';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any> {
    swipe: { direction: Hammer.DIRECTION_HORIZONTAL },
	pinch: { enable: false },
	rotate: { enable: false }
  };
}

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HammerModule,
		HttpClientModule,
		AppRoutingModule,
		NbLayoutModule,
		NbCheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		ThemeModule.forRoot(),
		NbSidebarModule.forRoot(),
		NbMenuModule.forRoot(),
		NbDateFnsDateModule.forRoot({
			parseOptions: { useAdditionalWeekYearTokens: true, useAdditionalDayOfYearTokens: true },
			formatOptions: { useAdditionalWeekYearTokens: true, useAdditionalDayOfYearTokens: true },
			format: 'dd/MM/yyyy'
		}),
		NbTimepickerModule.forRoot(),
		NbDialogModule.forRoot(),
		NbDatepickerModule.forRoot(),
		NbWindowModule.forRoot(),
		NbToastrModule.forRoot(),
		CoreModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		NbAlertModule,
		NbButtonModule,
		NbIconModule,
		SharedModule
	],
	providers: [
		PwaService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: MyHammerConfig
		  },
	],
	declarations: [AppComponent, AuthCallbackComponent],
	bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
// tslint:disable-next-line: only-arrow-functions
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http);
}